import * as main from './../../../mozgiel/assets/js/main.js'
import * as custom from './../../../mozgiel/assets/js/custom.js'
import * as counter from './../../../mozgiel/assets/js/counter.js'
import * as hamburger from './../../../mozgiel/assets/js/hamburger.js'
import * as parallax from './../../../mozgiel/assets/js/parallax.js'
import * as offcanvas from './../../../mozgiel/assets/js/offcanvas.js'
import * as bodyscroll from './../../../mozgiel/assets/js/bodyscroll.js'

/**
 * Add child theme functionality here
 */
(function ($) {
    const ensurePersonioHeading = function () {
        $('div[id^="applicationform"].entry-content.personio-integration-form-wrapper').each(function () {
            const $wrapper = $(this);

            if ($wrapper.children('.personio-application-title').length) {
                return;
            }

            $('<h3 class="personio-application-title">Jetzt bewerben</h3>')
                .insertBefore($wrapper.find('.personio-application-form-wrapper').first());
        });
    };

    const enhancePersonioFileInputs = function () {
        $('div[id^="applicationform"] form.personio-application-form input[type="file"]').each(function () {
            const $input = $(this);

            if ($input.closest('.personio-file-field').length) {
                return;
            }

            const $field = $('<div class="personio-file-field"></div>');
            const $button = $('<span class="personio-file-button">Datei auswählen</span>');
            const $filename = $('<span class="personio-file-name"></span>');

            $input.wrap($field);
            $input.after($button, $filename);

            $input.on('change', function () {
                const files = this.files;
                const $parent = $input.closest('.personio-file-field');

                if (!files || !files.length) {
                    $filename.text('');
                    $parent.removeClass('is-filled');
                    return;
                }

                if (files.length === 1) {
                    $filename.text(files[0].name);
                } else {
                    $filename.text(files.length + ' Dateien ausgewählt');
                }

                $parent.addClass('is-filled');
            });
        });
    };

    $(document).ready(function () {
        new WOW().init();
        ensurePersonioHeading();
        enhancePersonioFileInputs();
    });

    $(document).ajaxComplete(function () {
        ensurePersonioHeading();
        enhancePersonioFileInputs();
    });

})( jQuery );